import { useContext } from "react";
import { useHMSActions, useHMSStore, selectLocalPeer } from "@100mslive/react-sdk";

import { WorkshopContext } from "../contexts/workshop.context";

export const useChangeRole = () => {
  const {
    user: { role }
  } = useContext(WorkshopContext);
  const hmsActions = useHMSActions();
  const currentUser = useHMSStore(selectLocalPeer);

  const changeToDefaultRole = async (maxAttempts = 5, delayMs = 1000) => {
    let attempts = 0;

    const attemptRoleChange = async () => {
      try {
        console.log("attemptRoleChange", currentUser);
        if (!currentUser) {
          return {
            success: false,
            message: "User or peer not found"
          };
        }

        if (currentUser?.roleName?.toLowerCase() === role?.toLowerCase()) {
          return {
            success: true,
            message: "Role is already set"
          };
        }
        console.log("changing role", currentUser.id, role);
        // Change role using 100ms SDK
        hmsActions.changeRoleOfPeer(currentUser.id, role?.toLowerCase(), true);
        return {
          success: true,
          message: "Role changed successfully"
        };
      } catch (error) {
        console.error(`Role change attempt ${attempts + 1} failed:`, error);
        return {
          success: false,
          message: error.message
        };
      }
    };

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    while (attempts < maxAttempts) {
      const result = await attemptRoleChange();
      console.log("result", result);
      if (result.success) {
        return result;
      }

      attempts++;
      if (attempts < maxAttempts) {
        await delay(delayMs);
        console.log(`Retrying role change. Attempt ${attempts + 1}/${maxAttempts}`);
      }
    }

    return {
      success: false,
      message: `Failed to change role after ${maxAttempts} attempts`
    };
  };

  return { changeToDefaultRole };
};
